import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../rootState";
import { initialState } from ".";

const selectSlice = (state: RootState) => state.modal || initialState;

export const modalState = createSelector([selectSlice], (modal) => {
  return modal;
});

export const confirmModalState = createSelector([selectSlice], (modal) => {
  return modal.showConfirmModal;
});

export const showConnectWalletModalState = createSelector(
  [selectSlice],
  (modal) => {
    return modal.showConnectWalletModal;
  }
);
